import { Box } from '@mui/material';
import { ICasMRTCellProps } from './ICasMRTCellProps';

export default function CasMRTCellRenderPercent({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return value !== null && <Box textAlign="right">{value}%</Box>;
}
